import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetUgcEpisodeAggregateLinksQuery, useLazyGetUgcEpisodeLinksQuery } from '../../redux/apis/linkManagement/ugc/lMUgcEpisodeApiSlice'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import generateExcel from '../../helpers/generateExcel'

const UgcEpisodeReviewing = React.memo(() => {
  const context = useContext(AppSettings)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [fetchLinks] = useLazyGetUgcEpisodeLinksQuery()

  const handleDownload = (record) =>
    toast.promise(
      (async () => {
        const result = await fetchLinks({
          campaign: record.campaign_id,
          page: "*",
          fields: ['id', 'customers','url','campaign.campaign_name'].join(','),
          expand:["campaign"].join(',')
        })
        const rows = result.data?.data?.results ?? []
        generateExcel(
          rows.map(item => ({
            clients: item.customers?.join(', '),
            campaign: item.campaign?.campaign_name,
            url: item.url,
          })),
          `${record.campaign_name}`
        )
      })(),
      {
        pending: 'Preparing download…',
        success: 'Download ready!',
        error: 'Failed to download data'
      }
    )
  const { data, isLoading, isFetching, error, refetch, isUninitialized } =
    useGetUgcEpisodeAggregateLinksQuery({
      page: pagination.current,
      page_size: pagination.pageSize
    })

  let columns = [
    {
      title: 'Campain ID',
      dataIndex: 'campaign_id',
      key: 'campaign_id',

    },
    {
      title: 'CAMPAIGN NAME',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      search: true
    },
    {
      title: 'CUSTOMERS',
      dataIndex: 'customers',
      key: 'customers',
      search: true,
      render: (customers, record) => <>{customers?.map(x => x)?.join(', ')}</>
    },

    {
      title: 'SCREENSHOTS COUNT',
      dataIndex: 'to_review_count',
      key: 'to_review_count',
      search: true
    },

    {
      title: 'Actions',
      dataIndex: 'campaign_id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`/reviewing-screenshots/ugc-episode/campaign/${record?.campaign_id}`}
            className='btn btn-outline-theme'
          >
            Review
          </a>
          <button
            className='btn btn-outline-theme'
            onClick={() => handleDownload(record)}
          >
            Download
          </button>
        </div>
      )
    }
  ]
  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }
  useEffect(() => {
    console.log(error)
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !isUninitialized) {
        refetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch, isUninitialized])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching  } />

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default UgcEpisodeReviewing
